import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { getMaxSelectablePreviousDay } from '@/services/functions';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { ja } from 'date-fns/locale';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RangeDatePicker',
  props: {
    modelValue: {},
    maxRange: {},
    format: {},
    isError: { type: Boolean }
  },
  emits: ['update:modelValue', 'search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-100 range-date-picker", { 'range-date-picker-error': props.isError }])
  }, [
    _createVNode(_unref(VueDatePicker), {
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      class: "w-100",
      teleport: "body",
      locale: _unref(ja),
      "enable-time-picker": false,
      formats: { input: props.format },
      range: {
        maxRange: props.maxRange
      },
      "min-date": _unref(getMaxSelectablePreviousDay)(),
      "auto-apply": "",
      clearable: false,
      "multi-calendars": ""
    }, {
      "clear-icon": _withCtx(({ clear }) => [
        _createElementVNode("div", { onClick: clear }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["modelValue", "locale", "formats", "range", "min-date"])
  ], 2))
}
}

})